import api from '@/utils/axios';
import { unwrapItem, unwrapList } from '@/utils/apiHelpers';
import type { ApiOrderMessage, ApiOrderQuote, ApiPackageCategory } from './types';

export interface OrderQuotePayload {
  delivery_type_id: number;
  departure_secteur_id: number;
  arrival_secteur_id: number;
  departure_latitude?: number | null;
  departure_longitude?: number | null;
  arrival_latitude?: number | null;
  arrival_longitude?: number | null;
  estimated_weight: number;
  package_category_id?: number | null;
}

export async function listPackageCategories(): Promise<ApiPackageCategory[]> {
  const res = await api.get('/package-categories');
  return unwrapList<ApiPackageCategory>(res.data);
}

export async function fetchOrderQuote(payload: OrderQuotePayload): Promise<ApiOrderQuote> {
  const res = await api.post('/order-requests/quote', payload, { skipGlobalLoader: true });
  return unwrapItem<ApiOrderQuote>(res.data);
}

export async function fetchOrderMessages(orderId: number): Promise<ApiOrderMessage[]> {
  const res = await api.get(`/order-requests/${orderId}/messages`);
  const list = unwrapList<ApiOrderMessage>(res.data);
  // Garantit l'ordre chat standard (ancien → récent), même si l'API change
  return [...list].sort((a, b) => {
    const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
    if (ta !== tb) return ta - tb;
    return a.id - b.id;
  });
}

export async function sendOrderMessage(orderId: number, body: string): Promise<ApiOrderMessage> {
  const res = await api.post(`/order-requests/${orderId}/messages`, { body });
  return unwrapItem<ApiOrderMessage>(res.data);
}

export async function fetchRelayPointActivities(relayPointId: number) {
  const res = await api.get(`/admin/relay-points/${relayPointId}/activities`);
  return unwrapList(res.data);
}

export async function createRelayPointActivity(
  relayPointId: number,
  payload: { event_type: string; order_request_id?: number | null; notes?: string | null },
) {
  const res = await api.post(`/admin/relay-points/${relayPointId}/activities`, payload);
  return unwrapItem(res.data);
}
